/**
 * The AI role's scale: the designed violet-plum (#8b3a9e) as step 9, expanded
 * onto Radix plum's lightness curve by generate-scale.ts. Reserved for the
 * agent's own surfaces; the rule is in docs/specs/frontend/design-system/tokens.md.
 */
export const ai = {
  ai1: '#fefcff',
  ai2: '#fcf7fd',
  ai3: '#f8ecfc',
  ai4: '#f3e0f8',
  ai5: '#edd3f4',
  ai6: '#e4c4ec',
  ai7: '#d8b0e2',
  ai8: '#c995d6',
  ai9: '#8b3a9e',
  ai10: '#823494',
  ai11: '#8f46a0',
  ai12: '#4f1f5b',
};

export const aiA = {
  ai1: '#cd69ff05',
  ai2: '#a91ac609',
  ai3: '#a202d713',
  ai4: '#9f07c720',
  ai5: '#9804c02d',
  ai6: '#8c04ae3c',
  ai7: '#8100a14f',
  ai8: '#7d009c6a',
  ai9: '#690182c6',
  ai10: '#620078cb',
  ai11: '#65007cb9',
  ai12: '#370045e0',
};

export const aiDark = {
  ai1: '#171118',
  ai2: '#1e1421',
  ai3: '#311c36',
  ai4: '#402148',
  ai5: '#4c2855',
  ai6: '#593462',
  ai7: '#6e4478',
  ai8: '#8d589a',
  ai9: '#8b3a9e',
  ai10: '#9548a8',
  ai11: '#e09bf1',
  ai12: '#efd6f5',
};

export const aiDarkA = {
  ai1: '#17111800',
  ai2: '#c65cf90a',
  ai3: '#df66ff21',
  ai4: '#da5dfd36',
  ai5: '#df68fe44',
  ai6: '#e57eff52',
  ai7: '#e98cff6a',
  ai8: '#e88ffe90',
  ai9: '#df58ff94',
  ai10: '#e169fe9f',
  ai11: '#eda4fff0',
  ai12: '#f9dffff4',
};
